import store from "../store";

export function setAPIResponse(data: any, id: string): void {
    store.dispatch({
        type: 'setAPIResponse',
        payload: {
            data,
            id: id
        }
    })
}

export function setToken(token: string): void {
    store.dispatch({
        type: 'setToken',
        payload: {
            token
        }
    })
}

export function setAPIState(data:any , id:string):void{
    store.dispatch({
        type: 'setAPIState',
        payload: {
            data,
            id: id
        }
    })
}

// export function resetAPIState(): void {
//     store.dispatch({
//         type: 'resetAPIState',
//         payload: {}
//     })
// }

// export function resetAPIResponse(): void {
//     store.dispatch({
//         type: 'resetAPIResponse',
//         payload: {}
//     })
// }

// export function resetToken(): void {
//     store.dispatch({
//         type: 'resetToken',
//         payload: {}
//     })
// }

export function setValidationStatus(data: any, id: string): void {
    store.dispatch({
        type: "setValidationStatus",
        payload: {
            data,
            id
        }
    })
}

// export function resetValidationStatus(): void {
//     store.dispatch({
//         type: 'resetValidationStatus',
//         payload: {}
//     })
// }

export function resetAll():void{
    store.dispatch({
        type:'resetAll',
        payload:{}
    })
}